import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const DataCleanupPage = lazy(() =>
  import('../../pages/admin/data-cleanup/DataCleanupPage').then((m) => ({
    default: m.DataCleanupPage,
  })),
);

export const Route = createFileRoute('/admin/data-cleanup')({
  component: () => (
    <Suspense
      fallback={
        <Spinner
          style={{
            position: 'absolute',
            top: '25%',
            left: '50%',
            transform: 'translateX(-50%)',
          }}
        />
      }
    >
      <DataCleanupPage />
    </Suspense>
  ),
});
